import API_ENDPOINTS from "../config";

function parseApiResponse(data) {
  if (data?.ltResponseData?.responseData) {
    return JSON.parse(data.ltResponseData.responseData);
  }

  return data;
}

function normalizeStockDetail(data) {
  const parsed = parseApiResponse(data) ?? {};

  return {
    ...parsed,
    chartData: Array.isArray(parsed.chartData) ? parsed.chartData : [],
    histChartData: Array.isArray(parsed.histChartData) ? parsed.histChartData : [],
    stockSentiment: Array.isArray(parsed.stockSentiment) ? parsed.stockSentiment : [],
  };
}

async function fetchJson(endpoint, options = {}) {
  const response = await fetch(endpoint, options);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

function buildQuery(params = {}) {
  return new URLSearchParams(
    Object.entries(params).reduce((query, [key, value]) => {
      if (value !== null && value !== undefined) query[key] = value;
      return query;
    }, {})
  ).toString();
}

export async function fetchIndustry(secFilters) {
  return fetchJson(`${API_ENDPOINTS.INDUSTRY_LIST}?${buildQuery(secFilters)}`);
}

export async function fetchSector() {
  return fetchJson(API_ENDPOINTS.SECTOR_LIST);
}

export async function fetchStocksWithRange(filters) {
  return fetchJson(`${API_ENDPOINTS.DA_FILTER}?${buildQuery(filters)}`);
}

export async function fetchStockDetail(stockId, dateFrom, dateTo) {
  const data = await fetchJson(`${API_ENDPOINTS.STOCK_CHART}?${buildQuery({ stockId, dateFrom, dateTo })}`);
  return normalizeStockDetail(data);
}

export async function fetchMktPerformance(filters) {
  return fetchJson(`${API_ENDPOINTS.PERFORMANCE_LIST}?${buildQuery(filters)}`);
}

export async function fetchNseWeeklyTrend(tradingDays = 5) {
  const data = await fetchJson(`${API_ENDPOINTS.NSE_WEEKLY_TREND}?${buildQuery({ tradingDays })}`);
  const parsed = parseApiResponse(data);
  return Array.isArray(parsed) ? parsed : [];
}

export async function fetchStockHighlights(filters) {
  return fetchJson(`${API_ENDPOINTS.HM_STK_HILIGHT}?${buildQuery(filters)}`);
}

export async function fetchNegStockHighlights(filters) {
  return fetchJson(`${API_ENDPOINTS.HM_NEG_STK_HILIGHT}?${buildQuery(filters)}`);
}

export async function fetchIndustryHighlights(filters) {
  return fetchJson(`${API_ENDPOINTS.HM_IDS_HILIGHT}?${buildQuery(filters)}`);
}

export async function fetchStockSignals(filters) {
  return fetchJson(`${API_ENDPOINTS.DA_STOCK_SIGNALS}?${buildQuery(filters)}`);
}

export async function fetchWorldSentiment({ dateFrom, dateTo }) {
  return fetchJson(`/api/sentiment/world?${buildQuery({ dateFrom, dateTo })}`);
}

export async function fetchGlobalDrivers({ dateFrom, dateTo }) {
  return fetchJson(`/api/sentiment/events?${buildQuery({ dateFrom, dateTo })}`);
}

export async function updateStock(stockId, nizFlag, nizComments) {
  return fetchJson(`${API_ENDPOINTS.UPDATE_STOCK}?${buildQuery({
    stockId,
    nizFlag: Boolean(nizFlag),
    nizComments: nizComments ?? "",
  })}`, {
    method: "POST",
  });
}
